


export class AuthorForumTopicsView {

    constructor() {

        this.id = 'my-topics';
		
		this.box = document.getElementById(this.id);
		if (!this.box) {
			
			//throw new Error('#' + id + ' element missing');
			return false;
		}
		
		this.title = this.box.querySelector('.sc_title > strong');
		
		this.ul = this.box.querySelector('.ul');
		
		this.itemTemplate = this.ul.querySelector('.li')?.cloneNode(true);
    }

    render(state) { 

        if (!this.box) { return false;}
		if (!state) { return false;}

        const data = state.data;
		if (data && Object.hasOwn(data, 'title')) { this.title.textContent = data.title;}
		
		if (data && Object.hasOwn(data, 'totalCount')) {
			
			const dummies = this.ul.querySelectorAll('.dummy');
			dummies.forEach((el, index) => {
				
				const model = data.models[index];
				if (!model) {
					el.parentElement.remove();
					return;
				}
				
				el.dataset.id = model.content.id;
				
				const titleLink = el.querySelector('.title > a');
				titleLink.href = model.content.url;
				
				titleLink.textContent = model.content.title;
				
				el.querySelector('.date').textContent = model.created.date;

				el.classList.remove('dummy');
			});
		}

		this.ul.querySelectorAll('.li').forEach((li) => {
			if (!li.textContent.trim() && li.children.length === 0) { li.remove();}
		});
		
		this.box.classList.remove('dummy');
    }
}